var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFinancialStrategies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21.9375V24.1018",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.2021V13.2164",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 29.3736C22.4997 29.3736 27.8569 26.7165 27.8569 20.8022C27.8569 14.3736 24.6426 10.0879 18.214 6.87363L20.7426 3.61649C20.871 3.40278 20.9407 3.15892 20.9445 2.9096C20.9484 2.66029 20.8862 2.41439 20.7644 2.19684C20.6426 1.97929 20.4654 1.79781 20.2508 1.6708C20.0362 1.5438 19.7919 1.47578 19.5426 1.47363H10.4569C10.2075 1.47578 9.9632 1.5438 9.74862 1.6708C9.53405 1.79781 9.35687 1.97929 9.23504 2.19684C9.11321 2.41439 9.05106 2.66029 9.0549 2.9096C9.05873 3.15892 9.12841 3.40278 9.25686 3.61649L11.7854 6.89506C5.35686 10.1308 2.14258 14.4165 2.14258 20.8451C2.14258 26.7165 7.49972 29.3736 14.9997 29.3736Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8573 20.952C13.1188 21.2624 13.4479 21.5087 13.8193 21.6721C14.1908 21.8356 14.5947 21.9118 15.0002 21.8948C15.6199 21.9371 16.2319 21.7374 16.7074 21.3378C17.183 20.9382 17.4851 20.3697 17.5502 19.752C17.4851 19.1342 17.183 18.5658 16.7074 18.1662C16.2319 17.7666 15.6199 17.5669 15.0002 17.6091C14.3805 17.6514 13.7685 17.4517 13.2929 17.0521C12.8174 16.6525 12.5153 16.084 12.4502 15.4663C12.5101 14.8464 12.8107 14.2747 13.2875 13.874C13.7643 13.4733 14.3792 13.2756 15.0002 13.3234C15.3985 13.2991 15.7973 13.3633 16.1678 13.5115C16.5384 13.6597 16.8714 13.8882 17.1431 14.1806",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.466797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinancialStrategies);
export default __webpack_public_path__ + "static/media/icon-financial-strategies.e0bf1ae30522486d4d2d6761f339b170.svg";
export { ForwardRef as ReactComponent };